// 加价规则国际化文件
export default {
  salesConflict: {
    title: '规则重复，共 {count} 处冲突', save: '本次未保存，已填写的内容还在。',
    enable: '本次所选规则均未启用。请先调整以下冲突。',
    rule: '本次规则', type: '业务类型', existingRule: '与这条规则重复', priority: '优先级',
    period: '冲突规则有效期（UTC）', channels: '重叠渠道', action: '操作',
    withinBatch: '本批次内互相重复', view: '去查看', close: '关闭'
  },
  salesList: {
    details: '明细', amount: '固定金额', percentage: '百分比', from: '起', until: '止',
    amountUnitHint: '币种和计费单位沿用命中运价。'
  },
  salesPhaseTwo: {
    tabs: { sea: '海运', preport: '港前', lastmile: '尾程', rail: '铁路', express: '快递', air: '空运' },
    seaTypes: '海运类型', beginDate: '生效时间（UTC）', endDate: '截止时间（UTC）',
    remark: '备注', customers: '适用客户', conditions: '匹配条件', channels: '渠道金额',
    validity: '有效期（UTC）', unlimited: '不限制', retry: '重试',
    noConditions: '未设置条件，符合客户范围的运价都可参与匹配。',
    multipleMethods: '改用多计费模型',
    channelNames: { cargoWareX: 'CargoWareX', family: '沃行之家' },
    validation: {
      types: '请选择业务类型；只有海运类型可一起新增。',
      channels: '至少选择一个渠道。', name: '规则名称必填，最多 50 字。',
      priority: '优先级必须是大于或等于 0 的整数。', scope: '请选择客户或客户等级。',
      dates: '请检查有效期，截止时间不能早于生效时间。',
      conditions: '请填完整匹配条件，最多 20 条。',
      unsupportedCondition: '存在所选类型不支持的条件，请调整类型或条件。',
      amount: '请填写所选类型、渠道的金额配置。'
    }
  },
  // 模块标题和描述
  title: '加价规则',
  description: '管理各类加价规则信息',

  // 标签页导航
  tabs: {
    fcl: '整箱加价规则',
    preport: '港前加价规则',
    lastmile: '尾程加价规则'
  },

  // 整箱加价规则管理 (FCL)
  fcl: {
    // 页面标题
    title: '整箱加价规则管理',
    description: '管理整箱加价规则信息',
    createTitle: '新增整箱加价规则',
    editTitle: '编辑整箱加价规则',
    viewTitle: '查看整箱加价规则详情',

    // 工具栏按钮
    toolbar: {
      addRule: '新增规则',
      batchEnable: '批量启用',
      batchDisable: '批量禁用'
    },

    // 表格列标题
    columns: {
      rulesId: '规则ID',
      rulesType: '规则类型',
      laneIds: '航线',
      carrierIds: '船公司',
      pols: '起运港',
      pods: '卸货港',
      chargeItemId: '费用名称',
      currency: '币种',
      measure: '计费单位',
      enableFlag: '启用状态',
      createdBy: '创建人',
      modifiedBy: '修改人',
      dateCreated: '创建时间',
      dateModified: '修改时间',
      actions: '操作'
    },

    // 操作按钮
    actions: {
      view: '详情',
      edit: '编辑',
      more: '更多',
      enable: '启用',
      disable: '禁用'
    },

    // 状态文本
    status: {
      enabled: '启用',
      disabled: '禁用',
      unknown: '未知'
    },

    // 规则类型文本
    rulesType: {
      1: '整箱海运费',
      2: '港前运价',
      3: '尾程运价',
      4: '拼箱海运费',
      5: '空运运费',
      unknown: '未知'
    },

    // 批量操作确认信息
    batch: {
      singleConfirmTitle: '{action}确认',
      singleConfirmContent: '确定要{action}这条整箱运价加价规则吗？',
      enableConfirm: '批量启用确认',
      disableConfirm: '批量禁用确认',
      enableMessage: '确定要启用选中的 {count} 条规则吗？',
      disableMessage: '确定要禁用选中的 {count} 条规则吗？',
      singleEnableMessage: '确定要启用该规则吗？',
      singleDisableMessage: '确定要禁用该规则吗？',
      successEnable: '启用成功',
      successDisable: '禁用成功',
      successBatchEnable: '成功启用 {count} 条规则',
      successBatchDisable: '成功禁用 {count} 条规则',
      failedEnable: '启用失败',
      failedDisable: '禁用失败',
      failedBatchEnable: '批量启用失败',
      failedBatchDisable: '批量禁用失败'
    },

    // 提示信息
    messages: {
      selectEnableRules: '请先选择要启用的规则',
      selectDisableRules: '请先选择要禁用的规则',
      loadDataFailed: '加载数据失败',
      unknownError: '未知错误',
      missingRecordId: '无法查看详情：缺少记录ID',
      missingEditId: '无法编辑：缺少记录ID',
      clickTabToLoad: '点击 {tab} 标签页加载内容'
    },

    // 导出相关
    export: {
      filename: '加价规则列表',
      columns: {
        rulesId: '规则ID',
        rulesType: '规则类型',
        laneIds: '航线',
        carrierIds: '船公司',
        pols: '起运港',
        pods: '目的港',
        chargeItemName: '费用名称',
        currencyName: '币种',
        measure: '计费单位',
        enableFlag: '启用状态',
        dateCreated: '创建时间',
        dateModified: '修改时间'
      }
    },

    // 计费单位显示
    billingUnits: {
      allUnits: '所有计费单位',
      moreUnits: '+{count}'
    },

    // 导出数据单位
    exportUnits: {
      routes: '条航线',
      carriers: '家船公司',
      pols: '个起运港',
      pods: '个目的港',
      billingUnits: '个计费单位'
    }
  },

  // 港前加价规则管理
  preport: {
    title: '港前加价规则管理',
    description: '管理港前加价规则信息',
    createTitle: '新增港前加价规则',
    editTitle: '编辑港前加价规则',
    viewTitle: '查看港前加价规则详情',

    // 工具栏按钮
    toolbar: {
      addRule: '新增规则',
      batchEnable: '批量启用',
      batchDisable: '批量禁用'
    },

    // 表格列标题
    columns: {
      rulesId: '规则ID',
      rulesType: '规则类型',
      pols: '起运港',
      pods: '目的港',
      priceMethod: '运价类型',
      branchLines: '支线类型',
      regions: '起运地区域',
      chargeItemId: '费用名称',
      currency: '币种',
      measure: '计费单位',
      enableFlag: '启用状态',
      createdBy: '创建人',
      modifiedBy: '修改人',
      dateCreated: '创建时间',
      dateModified: '修改时间',
      actions: '操作'
    },
    pols: {
      popoverTitle: '起运港'
    },
    regions: {
      totalRegions: '共 {count} 个起运区域'
    },

    // 操作按钮
    actions: {
      view: '详情',
      edit: '编辑',
      more: '更多',
      enable: '启用',
      disable: '禁用'
    },

    // 状态文本
    status: {
      enabled: '启用',
      disabled: '禁用',
      unknown: '未知'
    },

    // 规则类型文本
    rulesType: {
      1: '整箱海运费',
      2: '港前运价',
      3: '尾程运价',
      4: '拼箱海运费',
      5: '空运运费',
      unknown: '未知'
    },

    // 运价类型文本
    priceMethod: {
      1: '直拖',
      2: '支线',
      3: '海铁',
      direct: '直拖',
      branchLine: '支线',
      seaRail: '海铁',
      unknown: '未知'
    },

    // 支线类型文本
    branchLines: {
      1: '铁路',
      2: '公路',
      3: '内河',
      allTypesTooltip: '所有支线类型',
      unknown: '未知'
    },

    // 批量操作确认信息
    batch: {
      enableConfirm: '批量启用确认',
      disableConfirm: '批量禁用确认',
      enableMessage: '确定要启用选中的 {count} 条规则吗？',
      disableMessage: '确定要禁用选中的 {count} 条规则吗？',
      singleConfirmTitle: '{action}确认',
      singleConfirmContent: '确定要{action}这条港前运价加价规则吗？',
      singleEnableMessage: '确定要启用该规则吗？',
      singleDisableMessage: '确定要禁用该规则吗？',
      successEnable: '启用成功',
      successDisable: '禁用成功',
      successBatchEnable: '成功启用 {count} 条规则',
      successBatchDisable: '成功禁用 {count} 条规则',
      failedEnable: '启用失败',
      failedDisable: '禁用失败',
      failedBatchEnable: '批量启用失败',
      failedBatchDisable: '批量禁用失败'
    },

    // 提示信息
    messages: {
      selectEnableRules: '请先选择要启用的规则',
      selectDisableRules: '请先选择要禁用的规则',
      loadDataFailed: '加载数据失败',
      unknownError: '未知错误',
      missingRecordId: '无法查看详情：缺少记录ID',
      missingEditId: '无法编辑：缺少记录ID',
      clickTabToLoad: '点击 {tab} 标签页加载内容'
    },

    // 导出相关
    export: {
      filename: '港前运价加价规则列表',
      columns: {
        rulesId: '规则ID',
        rulesType: '规则类型',
        pols: '起运港',
        pods: '目的港',
        priceMethod: '运价类型',
        branchLines: '支线类型',
        regions: '起运地区域',
        chargeItemName: '费用名称',
        currencyName: '币种',
        measure: '计费单位',
        enableFlag: '启用状态',
        dateCreated: '创建时间',
        dateModified: '修改时间'
      }
    },

    // 计费单位显示
    billingUnits: {
      allUnits: '所有计费单位',
      moreUnits: '+{count}'
    },

    // 导出数据单位
    exportUnits: {
      pols: '个起运港',
      pods: '个目的港',
      branchLines: '种支线类型',
      billingUnits: '个计费单位'
    }
  },

  // 尾程加价规则管理
  lastmile: {
    title: '尾程加价规则管理',
    description: '管理尾程加价规则信息',
    createTitle: '新增尾程加价规则',
    editTitle: '编辑尾程加价规则',
    viewTitle: '查看尾程加价规则详情',

    // 工具栏按钮
    toolbar: {
      addRule: '新增规则',
      batchEnable: '批量启用',
      batchDisable: '批量禁用'
    },

    // 表格列标题
    columns: {
      rulesId: '规则ID',
      rulesType: '规则类型',
      pods: '卸货港',
      regions: '配送地址',
      addressType: '地址类型',
      warehouseCode: '仓库代码',
      chargeItemId: '费用名称',
      currency: '币种',
      measure: '计费单位',
      enableFlag: '启用状态',
      createdBy: '创建人',
      modifiedBy: '修改人',
      dateCreated: '创建时间',
      dateModified: '修改时间',
      actions: '操作'
    },

    // 操作按钮
    actions: {
      view: '详情',
      edit: '编辑',
      more: '更多',
      enable: '启用',
      disable: '禁用'
    },

    // 状态文本
    status: {
      enabled: '启用',
      disabled: '禁用',
      unknown: '未知'
    },

    // 规则类型文本
    rulesType: {
      1: '整箱海运费',
      2: '港前运价',
      3: '尾程运价',
      4: '拼箱海运费',
      5: '空运运费',
      unknown: '未知'
    },

    // 地址类型文本
    addressType: {
      1: '第三方地址',
      2: '自营地址',
      unknown: '未知'
    },

    // 批量操作确认信息
    batch: {
      singleConfirmTitle: '{action}确认',
      singleConfirmContent: '确定要{action}这条尾程运价加价规则吗？',
      enableConfirm: '批量启用确认',
      disableConfirm: '批量禁用确认',
      enableMessage: '确定要启用选中的 {count} 条规则吗？',
      disableMessage: '确定要禁用选中的 {count} 条规则吗？',
      singleEnableMessage: '确定要启用该规则吗？',
      singleDisableMessage: '确定要禁用该规则吗？',
      successEnable: '启用成功',
      successDisable: '禁用成功',
      successBatchEnable: '成功启用 {count} 条规则',
      successBatchDisable: '成功禁用 {count} 条规则',
      failedEnable: '启用失败',
      failedDisable: '禁用失败',
      failedBatchEnable: '批量启用失败',
      failedBatchDisable: '批量禁用失败'
    },

    // 提示信息
    messages: {
      selectEnableRules: '请先选择要启用的规则',
      selectDisableRules: '请先选择要禁用的规则',
      loadDataFailed: '加载数据失败',
      unknownError: '未知错误',
      missingRecordId: '无法查看详情：缺少记录ID',
      missingEditId: '无法编辑：缺少记录ID',
      clickTabToLoad: '点击 {tab} 标签页加载内容'
    },

    // 导出相关
    export: {
      filename: '尾程运价加价规则列表',
      columns: {
        rulesId: '规则ID',
        rulesType: '规则类型',
        regions: '配送地址',
        chargeItemName: '费用名称',
        currencyName: '币种',
        measure: '计费单位',
        enableFlag: '启用状态',
        dateCreated: '创建时间',
        dateModified: '修改时间'
      }
    },

    // 计费单位显示
    billingUnits: {
      allUnits: '所有计费单位',
      moreUnits: '+{count}'
    },

    // 导出数据单位
    exportUnits: {
      regions: '个配送地址',
      billingUnits: '个计费单位'
    }
  },

  // 详情页面
  detail: {
    // 页面标题
    createTitle: '新增加价规则',
    editTitle: '编辑加价规则',
    viewTitle: '加价规则详情',
    copyTitle: '复制加价规则',

    // 基础信息
    basicInfo: '基础信息',
    laneName: '航线名称',
    carrier: '船公司',
    pol: '起运港',
    pod: '目的港',
    chargeItem: '费用名称',
    currency: '币种',
    billingUnit: '计费单位',
    ruleStatus: '规则状态',
    remarks: '备注',

    // 计费单位规则配置
    billingUnitRules: '计费单位规则配置',
    selectFeeFirst: '请先选择费用名称,系统将自动生成对应的计费单位规则',
    noBillingUnits: '当前选中的费用名称没有可用的计费单位',

    // 表格列标题
    columns: {
      billingUnit: '计费单位',
      t0Price: 'T0加价',
      t1Price: 'T1加价',
      t2Price: 'T2加价',
      t3Price: 'T3加价',
      internalSales: '内部销售'
    },

    // 占位符
    placeholders: {
      selectLane: '请选择航线名称',
      selectCarrier: '请选择船公司',
      selectPol: '请选择起运港',
      selectPod: '请选择目的港',
      selectChargeItem: '请选择费用名称',
      selectCurrency: '请选择币种',
      selectBillingUnit: '请选择计费单位',
      enterRemarks: '请输入备注',
      enterT0Price: '请输入T0加价',
      enterT1Price: '请输入T1加价',
      enterT2Price: '请输入T2加价',
      enterT3Price: '请输入T3加价',
      enterInternalSales: '请输入内部销售价格',
      autoSetByFee: '根据费用名称自动设置'
    },

    // 按钮
    back: '返回',
    save: '保存',
    edit: '编辑',
    copy: '复制',

    // 复制提示
    copyTip: '正在复制加价规则信息，规则编号将自动重新生成，请确认所有信息后保存',

    // 验证消息
    validation: {
      selectFeeRequired: '请选择费用名称',
      selectCurrencyRequired: '请选择币种'
    },

    // 成功消息
    messages: {
      copySuccess: '已复制加价规则信息到新增页面，规则编号将重新生成，请确认信息后保存',
      saveSuccess: '加价规则创建成功！',
      updateSuccess: '加价规则更新成功！',
      saveFailed: '保存失败',
      loadDataFailed: '加载数据失败',
      copyDataFailed: '复制数据加载失败',
      checkRequired: '请检查必填项'
    }
  },

  // 港前加价规则详情页
  preportDetail: {
    // 页面标题
    createTitle: '新增港前运价加价规则',
    editTitle: '编辑港前运价加价规则',
    viewTitle: '港前运价加价规则详情',
    copyTitle: '复制港前运价加价规则',

    // 基础信息
    basicInfo: '基础信息',
    priceMethod: '运价类型',
    priceMethodDirect: '直拖',
    priceMethodBranch: '支线',
    priceMethodRail: '海铁',
    branchLines: '支线类型',
    branchLineRailway: '铁路',
    branchLineHighway: '公路',
    branchLineWaterway: '内河',
    pols: '起运港',
    regions: '起运地区域',
    chargeItem: '费用名称',
    currency: '币种',
    billingUnit: '计费单位',
    ruleStatus: '规则状态',

    // 计费单位规则配置
    billingUnitRules: '计费单位规则配置',
    selectFeeFirst: '请先选择费用名称,系统将自动生成对应的计费单位规则',
    noBillingUnits: '当前选中的费用名称没有可用的计费单位',

    // 表格列标题
    columns: {
      billingUnit: '计费单位',
      t0Price: 'T0加价',
      t1Price: 'T1加价',
      t2Price: 'T2加价',
      t3Price: 'T3加价',
      internalSales: '内部销售'
    },

    // 占位符
    placeholders: {
      selectPriceMethod: '请选择运价类型',
      selectBranchLines: '请选择支线类型',
      selectPols: '请选择起运港',
      selectRegions: '请选择起运地区域',
      selectChargeItem: '请选择费用名称',
      selectCurrency: '请选择币种',
      selectBillingUnit: '请选择计费单位',
      enterT0Price: '请输入T0加价',
      enterT1Price: '请输入T1加价',
      enterT2Price: '请输入T2加价',
      enterT3Price: '请输入T3加价',
      enterInternalSales: '请输入内部销售价格',
      autoSetByFee: '根据费用名称自动设置'
    },

    // 按钮
    back: '返回',
    save: '保存',
    edit: '编辑',
    copy: '复制',

    // 复制提示
    copyTip: '正在复制港前运价加价规则信息，规则编号将自动重新生成，请确认所有信息后保存',

    // 验证消息
    validation: {
      selectPriceMethodRequired: '请选择运价类型',
      selectBranchLinesRequired: '请选择支线类型',
      selectPolsRequired: '请选择起运港',
      selectChargeItemRequired: '请选择费用名称',
      selectCurrencyRequired: '请选择币种'
    },

    // 成功消息
    messages: {
      copySuccess: '已复制港前运价加价规则信息到新增页面，规则编号将重新生成，请确认信息后保存',
      saveSuccess: '港前运价加价规则创建成功！',
      updateSuccess: '港前运价加价规则更新成功！',
      saveFailed: '保存失败',
      loadDataFailed: '加载数据失败',
      copyDataFailed: '复制数据加载失败',
      checkRequired: '请检查必填项',
      unknownError: '未知错误'
    },

    // 状态文本
    status: {
      enabled: '启用',
      disabled: '禁用',
      expired: '失效'
    },

    // 新增的国际化键值
    aiRecognition: 'AI识别',
    addRegion: '添加区域',
    province: '省份',
    city: '城市',
    district: '区/县',
    street: '街道',
    community: '社区',
    operation: '操作',
    delete: '删除',
    selectProvince: '请选择省份',
    selectCity: '请选择城市',
    selectDistrict: '请选择区/县',
    selectStreet: '请选择街道',
    selectCommunity: '请选择社区',

    // 国家相关
    countryChina: '中国'
  },

  // 尾程加价规则详情页
  lastmileDetail: {
    // 页面标题
    createTitle: '新增尾程运价加价规则',
    editTitle: '编辑尾程运价加价规则',
    viewTitle: '尾程运价加价规则详情',
    copyTitle: '复制尾程运价加价规则',

    // 基础信息
    basicInfo: '基础信息',
    pods: '目的港',
    regions: '配送地址',
    addressType: '地址类型',
    addressTypeThirdParty: '第三方地址',
    addressTypeSelfOperated: '自营地址',
    warehouseCode: '仓库代码',
    chargeItem: '费用名称',
    currency: '币种',
    billingUnit: '计费单位',
    ruleStatus: '规则状态',

    // 计费单位规则配置
    billingUnitRules: '计费单位规则配置',
    selectFeeFirst: '请先选择费用名称,系统将自动生成对应的计费单位规则',
    noBillingUnits: '当前选中的费用名称没有可用的计费单位',

    // 表格列标题
    columns: {
      billingUnit: '计费单位',
      t0Price: 'T0加价',
      t1Price: 'T1加价',
      t2Price: 'T2加价',
      t3Price: 'T3加价',
      internalSales: '内部销售'
    },

    // 占位符
    placeholders: {
      selectPods: '请选择目的港',
      selectRegions: '请选择配送地址',
      selectChargeItem: '请选择费用名称',
      selectCurrency: '请选择币种',
      selectBillingUnit: '请选择计费单位',
      enterT0Price: '请输入T0加价',
      enterT1Price: '请输入T1加价',
      enterT2Price: '请输入T2加价',
      enterT3Price: '请输入T3加价',
      enterInternalSales: '请输入内部销售价格'
    },

    // 按钮
    back: '返回',
    save: '保存',
    edit: '编辑',
    copy: '复制',

    // 复制提示
    copyTip: '正在复制尾程运价加价规则信息，规则编号将自动重新生成，请确认所有信息后保存',

    // 验证消息
    validation: {
      selectPodsRequired: '请选择目的港',
      selectChargeItemRequired: '请选择费用名称',
      selectCurrencyRequired: '请选择币种'
    },

    // 成功消息
    messages: {
      copySuccess: '已复制尾程运价加价规则信息到新增页面，规则编号将重新生成，请确认信息后保存',
      saveSuccess: '尾程运价加价规则创建成功！',
      updateSuccess: '尾程运价加价规则更新成功！',
      saveFailed: '保存失败',
      loadDataFailed: '加载数据失败',
      copyDataFailed: '复制数据加载失败',
      checkRequired: '请检查必填项',
      unknownError: '未知错误'
    },

    // 状态文本
    status: {
      enabled: '启用',
      disabled: '禁用'
    },

    // 新增的国际化键值
    aiRecognition: 'AI识别',
    addRegion: '添加区域',
    addressTypeLabel: '地址类型',
    thirdPartyAddress: '第三方地址',
    amazonWarehouse: '亚马逊仓库',
    easyWarehouse: '易仓',
    country: '国家',
    state: '州',
    city: '市',
    region: '区域',
    warehouseCodeLabel: '仓库代码',
    easyWarehouseCode: '易仓代码',
    operation: '操作',
    delete: '删除',
    selectAddressType: '请选择地址类型',
    selectCountry: '请选择国家',
    selectState: '请选择州',
    selectCity: '请选择市',
    selectRegion: '请选择区域',
    selectAmazonWarehouse: '请选择亚马逊仓库',
    selectEasyWarehouse: '请选择易仓',
    selectChargeItem: '请选择费用名称',
    selectBillingUnit: '请选择计费单位',
    autoSetByFee: '根据费用名称自动设置',
    enterT0Price: '请输入T0加价',
    enterT1Price: '请输入T1加价',
    enterT2Price: '请输入T2加价',
    enterT3Price: '请输入T3加价',
    enterInternalSalesPrice: '请输入内部销售价格'
  },

  // 通用文本
  common: {
    loading: '加载中...',
    noData: '暂无数据',
    confirm: '确认',
    cancel: '取消',
    save: '保存',
    edit: '编辑',
    delete: '删除',
    view: '查看',
    enable: '启用',
    disable: '禁用',
    copy: '复制',
    back: '返回',
    submit: '提交',
    reset: '重置',
    search: '搜索',
    filter: '筛选',
    export: '导出',
    import: '导入',
    refresh: '刷新',
    close: '关闭',
    ok: '确定',
    yes: '是',
    no: '否'
  },
  filterPlaceholders: {
    enterRulesId: '请输入规则ID',
    selectPriceMethod: '请选择运价类型',
    selectBranchLines: '请选择支线类型',
    selectPol: '请选择起运港',
    selectPod: '请选择目的港',
    selectChargeItem: '请选择费用名称',
    selectCurrency: '请选择币种',
    selectBillingUnit: '请选择计费单位',
    selectEnableFlag: '请选择启用状态',
    selectRuleStatus: '请选择规则状态',
    selectDateCreated: '请选择创建日期',
    selectDateModified: '请选择修改日期',
    selectDateCreatedRange: '请选择创建时间范围',
    selectDateModifiedRange: '请选择修改时间范围',
    enterCreatedBy: '请输入创建人',
    enterModifiedBy: '请输入修改人',
    enterWarehouseCode: '请输入仓库代码',
    selectAddressType: '请选择地址类型',
    selectRulesType: '请选择规则类型'
  },

  // 枚举标签
  enums: {
    conditionField: {
      carrier: 'Carrier（船司）',
      pol: 'POL（起运港）',
      pod: 'POD（卸货港）',
      routeCategory: '航线分类',
      supplier: '供应商',
      contractNo: '约号',
      nac: 'NAC',
      cargoType: '货物类型'
    },
    conditionOperator: {
      include: '包含',
      eq: '等于',
      notInclude: '不包含',
      neq: '不等于'
    },
    increasePriceType: {
      percent: '按照百分比',
      amount: '按照具体金额'
    }
  },

  // 商务加价规则列表页
  businessFcl: {
    exportFilename: '商务加价规则列表',
    toolbar: {
      addRule: '新增规则',
      batchEnableCount: '批量启用 ({count})',
      batchDisableCount: '批量禁用 ({count})',
      batchDeleteCount: '批量删除 ({count})'
    },
    columns: {
      officeIds: '分公司',
      rulesId: '规则ID',
      ruleName: '规则名称',
      rulePriority: '优先级',
      increasePriceType: '加价类型',
      enable: '启用状态',
      validDate: '有效期',
      createdBy: '创建人',
      modifiedBy: '修改人',
      dateCreated: '创建时间',
      dateModified: '修改时间',
      actions: '操作'
    },
    status: {
      enabled: '启用',
      disabled: '禁用'
    },
    placeholders: {
      increasePriceType: '请选择加价类型'
    },
    increasePriceType: {
      percent: '按百分比',
      amount: '按具体金额'
    },
    actions: {
      view: '详情',
      edit: '编辑',
      more: '更多',
      copy: '复制',
      delete: '删除'
    },
    modal: {
      confirmEnable: '确认启用',
      confirmDisable: '确认禁用',
      enableContent: '确定要启用该规则吗？',
      disableContent: '确定要禁用该规则吗？',
      deleteTitle: '确认删除',
      deleteContent: '确定要删除该规则吗？删除后不可恢复',
      deleteOkText: '确认删除',
      batchEnableTitle: '批量启用确认',
      batchEnableContent: '确定要启用选中的 {count} 条规则吗？',
      batchDisableTitle: '批量禁用确认',
      batchDisableContent: '确定要禁用选中的 {count} 条规则吗？',
      batchDeleteTitle: '批量删除确认',
      batchDeleteContent: '确定要删除选中的 {count} 条规则吗？删除后不可恢复',
      batchDeleteOkText: '确认删除',
      confirm: '确认',
      cancel: '取消'
    },
    messages: {
      enableSuccess: '启用成功',
      disableSuccess: '禁用成功',
      deleteSuccess: '操作成功',
      batchEnableSuccess: '成功启用 {count} 条规则',
      batchDisableSuccess: '成功禁用 {count} 条规则',
      batchDeleteSuccess: '成功删除 {count} 条规则',
      selectEnableRules: '请先选择要启用的规则',
      selectDisableRules: '请先选择要禁用的规则',
      selectDeleteRules: '请先选择要删除的规则'
    },
    export: {
      columns: {
        rulesId: '规则ID',
        ruleName: '规则名称',
        rulePriority: '优先级',
        increasePriceType: '加价类型',
        enable: '启用状态',
        validDate: '有效期',
        dateCreated: '创建时间',
        dateModified: '修改时间'
      }
    }
  },

  // 商务加价规则详情页
  businessFclDetail: {
    pageTitle: {
      copy: '复制商务加价规则',
      create: '新增商务加价规则',
      edit: '编辑商务加价规则',
      view: '商务加价规则详情'
    },
    ruleStatus: '规则状态：',
    status: {
      enabled: '启用',
      disabled: '禁用',
      expired: '失效'
    },
    buttons: {
      back: '返回',
      save: '保存',
      edit: '编辑',
      copy: '复制'
    },
    copyAlert: '正在复制商务加价规则信息，规则编号将自动重新生成，请确认所有信息后保存',
    basicInfo: {
      title: '规则基础信息',
      ruleId: '规则ID',
      ruleName: '规则名称',
      rulePriority: '规则优先级',
      officeIds: '所属公司',
      beginDate: '有效期开始',
      endDate: '有效期结束'
    },
    placeholders: {
      ruleName: '请输入规则名称',
      rulePriority: '数值越大优先执行，默认1',
      officeIds: '请选择所属公司',
      beginDate: '请选择开始日期',
      endDate: '请选择结束日期',
      condField: '请选择字段',
      condValue: '请选择',
      condValueInput: '请输入',
      markupPercent: '请输入百分比',
      markupBoxAmount: '请输入'
    },
    validation: {
      ruleName: '请输入规则名称',
      rulePriority: '请输入规则优先级',
      officeIds: '请选择所属公司',
      beginDate: '请选择有效期开始',
      endDate: '请选择有效期结束',
      condValue: '此项为必填项'
    },
    hints: {
      rulePriority: '数值越大优先执行，默认 1',
      markupPercent: '销售卖价 = 成本价 × (1 + 加价百分比%)',
      markupBoxAmount: '销售卖价 = 成本价 + 对应箱型加价金额；留空表示该箱型不加价'
    },
    conditionSection: {
      title: '满足以下条件，自动匹配运价信息',
      groupRelAnd: '并且',
      groupRelOr: '或',
      groupInnerRelation: '组内关系',
      groupOuterRelation: '与上一组关系',
      addCondition: '添加条件',
      addGroup: '添加联合条件',
      maxConditionsTooltip: '最多支持 {count} 条条件'
    },
    markupSection: {
      title: '加价信息（基于已匹配运价信息的基础海运费币制）',
      addBoxType: '添加箱型'
    },
    messages: {
      maxConditions: '单条规则最多支持 {count} 条条件',
      allBoxTypesAdded: '已添加全部箱型',
      saveSuccess: '商务加价规则创建成功！',
      updateSuccess: '商务加价规则更新成功！',
      copySuccess: '已复制商务加价规则信息到新增页面，规则编号将重新生成，请确认信息后保存',
      loadFailed: '商务加价规则加载失败，请稍后重试',
      copyLoadFailed: '复制规则加载失败，请稍后重试',
      saveFailed: '保存失败，请检查必填项'
    }
  },

  // 销售加价规则列表
  salesMarkup: {
    autoMatch: '按每条运价自动匹配',
    businessType: '业务类型',
    types: { FCL: '海运整箱', LCL: '海运拼箱', RORO: '滚装', BULK: '散杂', RAIL: '铁路', EXPRESS: '快递', AIR: '空运', PRE_PORT: '港前', LAST_MILE: '尾程' },
    markup: '加价',
    exportFilename: '销售加价规则列表',
    toolbar: {
      addRule: '新增规则',
      batchEnableCount: '批量启用 ({count})',
      batchDisableCount: '批量禁用 ({count})',
      batchDeleteCount: '批量删除 ({count})'
    },
    columns: {
      rulesId: '规则ID',
      ruleName: '规则名称',
      priority: '优先级',
      condition: '加价条件',
      fclEnable: '海运整箱(FCL)',
      lclEnable: '海运拼箱(LCL)',
      airEnable: '空运(Air)',
      prePortEnable: '港前运价',
      lastMileEnable: '尾程运价',
      enabled: '启用状态',
      dateCreated: '创建时间',
      dateModified: '修改时间',
      createdBy: '创建人',
      modifiedBy: '修改人',
      actions: '操作'
    },
    status: {
      enabled: '启用',
      disabled: '禁用'
    },
    scopeType: {
      specificClient: '指定客户',
      clientLevel: '客户等级',
      all: '全部'
    },
    condition: {
      scope: '适用范围',
      carrier: '船公司',
      airline: '航空公司',
      route: '卸货港航线分类',
      pol: '起运港',
      pod: '卸货港',
      polAirport: '起运机场',
      podAirport: '目的机场'
    },
    actions: {
      view: '详情',
      edit: '编辑',
      more: '更多',
      copy: '复制',
      delete: '删除'
    },
    modal: {
      confirmEnable: '确认启用',
      confirmDisable: '确认禁用',
      enableContent: '确定要启用该规则吗？',
      disableContent: '确定要禁用该规则吗？',
      deleteTitle: '确认删除',
      deleteContent: '确定要删除该规则吗？删除后不可恢复',
      deleteOkText: '确认删除',
      batchEnableTitle: '批量启用确认',
      batchEnableContent: '确定要启用选中的 {count} 条规则吗？',
      batchDisableTitle: '批量禁用确认',
      batchDisableContent: '确定要禁用选中的 {count} 条规则吗？',
      batchDeleteTitle: '批量删除确认',
      batchDeleteContent: '确定要删除选中的 {count} 条规则吗？删除后不可恢复',
      batchDeleteOkText: '确认删除',
      confirm: '确认',
      cancel: '取消'
    },
    messages: {
      loadFailed: '加载数据失败',
      missingId: '缺少记录ID',
      enableSuccess: '启用成功',
      disableSuccess: '禁用成功',
      deleteSuccess: '删除成功',
      batchEnableSuccess: '成功启用 {count} 条规则',
      batchDisableSuccess: '成功禁用 {count} 条规则',
      batchDeleteSuccess: '成功删除 {count} 条规则',
      selectEnableRules: '请先选择要启用的规则',
      selectDisableRules: '请先选择要禁用的规则',
      selectDeleteRules: '请先选择要删除的规则'
    }
  },

  // 销售加价规则详情页
  salesMarkupDetail: {
    pageTitle: {
      copy: '复制销售加价规则',
      create: '新增销售加价规则',
      edit: '编辑销售加价规则',
      view: '销售加价规则详情'
    },
    ruleStatus: '规则状态：',
    status: {
      enabled: '启用',
      disabled: '禁用'
    },
    buttons: {
      back: '返回',
      save: '保存',
      edit: '编辑',
      copy: '复制'
    },
    copyAlert: '正在复制销售加价规则信息，规则编号将自动重新生成，请确认所有信息后保存',
    basicInfo: {
      title: '基础信息',
      ruleId: '规则ID',
      ruleName: '规则名称',
      priority: '优先级'
    },
    conditionSection: {
      title: '加价条件',
      hint: '以下条件为可选配置，不选则表示该条件不限。多个条件之间为「且」的关系。',
      scopeType: '适用范围',
      clients: '选择客户',
      clientLevels: '选择等级',
      carrier: '船公司',
      airline: '航空公司',
      route: '卸货港航线分类',
      pol: '起运港',
      pod: '卸货港',
      polAirport: '起运机场',
      podAirport: '目的机场'
    },
    businessSection: {
      title: '业务类型加价配置',
      hint: '一条规则只设置一种业务，修改后只影响该业务。',
      fcl: '启用海运整箱(FCL)加价',
      lcl: '启用海运拼箱(LCL)加价',
      air: '启用空运(Air)加价',
      prePort: '启用港前运价加价',
      lastMile: '启用尾程运价加价'
    },
    placeholders: {
      ruleName: '请输入规则名称',
      priority: '数值越大优先执行，默认 100',
      scopeType: '请选择适用范围',
      clients: '请选择客户',
      clientLevels: '请选择客户等级',
      carrier: '请选择船公司',
      airline: '请选择航空公司',
      route: '请选择卸货港航线分类',
      pol: '请选择起运港',
      pod: '请选择卸货港',
      polAirport: '请选择起运机场',
      podAirport: '请选择目的机场',
      config: '请输入加价配置（JSON格式）'
    },
    validation: {
      ruleName: '请输入规则名称',
      priority: '请输入优先级',
      clientIds: '请选择客户',
      clientLevels: '请选择客户等级'
    },
    hints: {
      priority: '数值越大优先执行，默认 100'
    },
    messages: {
      loadFailed: '加载数据失败',
      saveSuccess: '销售加价规则创建成功！',
      updateSuccess: '销售加价规则更新成功！',
      copySuccess: '已复制销售加价规则信息到新增页面，规则编号将重新生成，请确认信息后保存',
      checkRequired: '请检查必填项'
    },
    businessConfig: {
      markupMethod: '加价方式',
      perContainer: '按箱型',
      perUnit: '按单价',
      markupType: '加价类型',
      amount: '金额',
      percentage: '百分比',
      percentageHint: '如输入 5 表示 5%',
      containerConfig: '箱型加价配置',
      addContainer: '添加箱型',
      selectContainer: '选择箱型',
      containerEmpty: '请点击「添加箱型」配置各箱型加价',
      unitPrice: '单价加价',
      amountPlaceholder: '加价金额',
      percentagePlaceholder: '加价百分比',
      airMatrix: '密度 × 重量段加价矩阵',
      addDensityLevel: '添加密度区间',
      selectDensity: '请选择密度区间',
      airMatrixHint: '各数值单位与基础空运费一致，留空表示该段不加价',
      airMatrixEmpty: '请点击「添加密度区间」配置加价矩阵',
      densityInterval: '密度区间',
      actions: '操作'
    }
  },
  businessSea: {
    tabTitle: '海运',
    pageTitles: {
      create: '新增海运商务加价规则',
      edit: '编辑海运商务加价规则',
      view: '查看海运商务加价规则'
    },
    sections: {
      basic: '规则基础信息',
      conditions: '匹配条件',
      markups: '分业务类型加价金额'
    },
    fields: {
      rulesId: '规则ID',
      businessTypes: '业务类型',
      ruleName: '规则名称',
      rulePriority: '规则优先级',
      companyIds: '所属公司',
      validity: '有效期',
      increasePriceType: '加价类型',
      containerTypes: '适用箱型',
      percentageValue: '统一加价百分比',
      unitMarkup: '单价加价值'
    },
    businessTypes: {
      fcl: '整箱',
      lcl: '拼箱',
      roro: '滚装',
      bulk: '散杂'
    },
    conditionFields: {
      carrier: '承运人',
      pol: '起运港(POL)',
      pod: '卸货港(POD)',
      routeCategory: '卸货港航线分类',
      supplier: '供应商',
      contractNo: '约号',
      nac: 'NAC',
      cargoType: '货物类型',
      por: '收货地(POR)',
      pdl: '目的港(PDL)',
      directFlag: '直达/中转',
      transitPort: '中转港',
      containerOwner: '箱属',
      polWharf: '起运港码头',
      podWharf: '目的港码头',
      polCountry: '起运国家',
      pdlCountry: '目的国家',
      polCity: '起运城市',
      pdlCity: '目的城市',
      routeCode: '航线代码'
    },
    conditionValues: {
      direct: '直达',
      transit: '中转',
      unspecified: '不指定',
      coc: 'COC-承运人箱',
      soc: 'SOC-货主箱'
    },
    conditions: {
      hint: '条件组内、条件组之间均可选择且或或；组间关系表示当前组与上一组的关系，并按页面顺序计算。条件值支持输入多个标签。',
      groupTitle: '条件组 {index}',
      groupInnerRelation: '组内关系',
      groupOuterRelation: '与上一组关系',
      and: '且',
      or: '或',
      in: '包含',
      notIn: '不包含'
    },
    markupTypes: {
      perContainer: '按箱型加价',
      perUnit: '按单价加价'
    },
    priceTypes: {
      amount: '固定金额',
      percentage: '百分比'
    },
    markups: {
      selectBusinessTypeFirst: '请先选择业务类型，再配置各类型加价金额',
      title: '基础海运费加价金额',
      amount: '金额',
      addColumns: '添加箱型列',
      removeColumn: '删除 {container} 箱型列',
      containerValue: '{container} 加价值',
      unitPrice: '单价加价',
      notApplicable: '-',
      currencyHint: '加价币种与基础费用一致',
      percentageHint: '百分比数值，如 5 表示 5%',
      methodHint: '加价方式按业务类型自动派生：整箱按箱型加价，拼箱/滚装/散杂按单价加价',
      containerHint: '选择要添加到加价金额表的箱型列（未勾选箱型不参与本规则加价）'
    },
    status: {
      enabled: '启用',
      disabled: '禁用',
      expired: '失效'
    },
    list: {
      exportFilename: '海运商务加价规则',
      conditionsCount: '共 {count} 条匹配条件',
      markupsCount: '共 {count} 项加价金额',
      perUnitValue: '{value}/单位',
      unlimited: '不限',
      moreItems: '另有 {count} 项',
      notConfigured: '未配置',
      longTermActive: '长期有效',
      longTerm: '长期',
      columns: {
        rulesId: '规则ID',
        businessTypes: '业务类型',
        ruleName: '规则名称',
        companyIds: '所属公司',
        rulePriority: '优先级',
        conditions: '规则条件',
        markupAmounts: '加价金额',
        status: '状态',
        validity: '有效期',
        createdBy: '创建人',
        dateCreated: '创建时间',
        modifiedBy: '修改人',
        dateModified: '修改时间',
        actions: '操作'
      }
    },
    actions: {
      add: '新增规则',
      batchEnable: '批量启用（{count}）',
      batchDisable: '批量禁用（{count}）',
      batchValidity: '调整有效期（{count}）',
      batchDelete: '批量删除（{count}）',
      view: '查看',
      edit: '编辑',
      more: '更多',
      disable: '禁用',
      enable: '启用',
      delete: '删除',
      removeGroup: '删除条件组',
      removeCondition: '删除条件',
      insertCondition: '在下方添加条件',
      convertToGroup: '添加联合条件',
      addCondition: '添加条件',
      addGroup: '添加条件组',
      save: '保存',
      cancel: '取消',
      confirm: '确认'
    },
    batchValidity: {
      title: '批量调整有效期',
      selectedCount: '已选择 {count} 条规则，保存后将统一更新有效期。',
      validityRange: '新有效期',
      startDate: '请选择生效日期',
      endDate: '请选择失效日期',
      required: '请选择完整有效期',
      invalidRange: '失效日期不能早于生效日期'
    },
    placeholders: {
      autoGenerated: '保存后自动生成',
      ruleName: '请输入规则名称',
      rulePriority: '请输入 1 至 9999',
      companyIds: '请选择所属公司',
      beginDate: '请选择生效时间',
      endDate: '请选择失效时间',
      conditionField: '请选择条件字段',
      conditionValue: '输入后按回车生成标签',
      containerTypes: '请选择适用箱型',
      markupValue: '请输入加价值',
      rulesId: '请输入规则ID',
      pod: '请选择卸货港',
      increasePriceType: '请选择加价类型',
      status: '请选择状态',
      validity: '请选择有效期',
      dateCreated: '请选择创建时间',
      dateModified: '请选择修改时间'
    },
    validation: {
      businessTypes: '请至少选择一个业务类型',
      ruleName: '请输入规则名称',
      rulePriority: '请输入规则优先级',
      companyIds: '请选择所属公司',
      validity: '请选择完整有效期',
      conditions: '请为每条匹配条件填写至少一个条件值',
      containerMarkups: '请至少配置一个箱型及其加价值',
      unitMarkup: '请填写单价加价值'
    },
    messages: {
      companyLoadFailed: '可操作公司加载失败，请稍后重试',
      containerLoadFailed: '箱型数据加载失败，已保留常用箱型',
      missingId: '缺少规则ID，无法继续操作',
      loadFailed: '商务加价规则加载失败，请稍后重试',
      saveSuccess: '商务加价规则创建成功，当前为禁用状态',
      updateSuccess: '商务加价规则更新成功',
      saveFailed: '商务加价规则保存失败，请检查表单后重试',
      clickTabToLoad: '点击标签页加载内容',
      noVisibleTabs: '当前账号没有可访问的商务加价业务类型',
      noTabPermission: '当前账号无权访问该商务加价业务类型',
      noActionPermission: '当前账号无权执行该操作',
      disableSuccess: '规则禁用成功',
      enableSuccess: '规则启用成功',
      operationFailed: '操作失败，请稍后重试',
      deleteSuccess: '规则删除成功',
      batchEnableSuccess: '规则批量启用成功',
      batchDisableSuccess: '规则批量禁用成功',
      batchValiditySuccess: '已更新 {count} 条规则的有效期',
      batchValidityFailed: '批量调整有效期失败，请稍后重试',
      batchDeleteSuccess: '规则批量删除成功'
    },
    confirm: {
      disableTitle: '确认禁用规则',
      disableContent: '禁用后该规则将不再参与价格计算，是否继续？',
      enableTitle: '确认启用规则',
      enableContent: '启用后规则将在有效期内参与价格计算，是否继续？',
      deleteTitle: '确认删除规则',
      deleteContent: '删除后不可恢复，是否继续？',
      batchEnableTitle: '确认批量启用',
      batchEnableContent: '确认启用选中的 {count} 条规则？',
      batchDisableTitle: '确认批量禁用',
      batchDisableContent: '确认禁用选中的 {count} 条规则？',
      batchDeleteTitle: '确认批量删除',
      batchDeleteContent: '确认删除选中的 {count} 条规则？删除后不可恢复。'
    }
  },
  businessOther: {
    routeTitle: '商务加价规则详情',
    businessTypes: {
      preport: '港前',
      lastmile: '尾程',
      air: '空运',
      rail: '铁路',
      express: '快递'
    },
    pageTitles: {
      create: '新增{type}商务加价规则',
      edit: '编辑{type}商务加价规则',
      view: '查看{type}商务加价规则'
    },
    sections: {
      markups: '加价金额'
    },
    conditionFields: {
      supplier: '供应商',
      cargoType: '货物类型',
      containerOwner: '箱属',
      transportMode: '运输方式',
      originCountry: '起运国家',
      originProvince: '起运省份',
      originCity: '起运城市',
      originDistrict: '起运区县',
      originTown: '起运乡镇',
      originCommunity: '起运社区',
      originAddress: '起运地址',
      zipCode: '邮政编码',
      originWarehouseType: '起运仓库类型',
      originWarehouse: '起运仓库',
      pol: '起运港',
      polWharf: '起运码头',
      loadingStation: '装货站',
      departureAirport: '起飞机场',
      airportCargoStation: '机场货站',
      dischargePort: '卸货港',
      dischargeWharf: '卸货码头',
      dischargeStation: '卸货站',
      dischargeAirport: '卸货机场',
      deliveryCountry: '送达国家',
      deliveryProvince: '送达省份',
      deliveryCity: '送达城市',
      deliveryDistrict: '送达区县',
      deliveryAddress: '送达地址',
      deliveryWarehouseType: '送达仓库类型',
      deliveryWarehouse: '送达仓库',
      airline: '航空公司',
      packageType: '包装类型',
      routeLevel: '航线等级',
      contractNo: '约号',
      nac: 'NAC',
      destCountry: '目的国家',
      destProvince: '目的省份',
      destCity: '目的城市',
      destDistrict: '目的区县',
      destAddress: '目的地址',
      destAirport: '目的机场',
      destAirportRoute: '目的机场航线',
      directFlag: '直达/中转',
      flightNo: '航班号',
      railwayCompany: '铁路公司',
      departureStation: '发车站',
      destStation: '目的站',
      exitPort: '出境口岸',
      entryPort: '入境口岸',
      transitClause: '中转条款',
      transitStation: '中转站',
      routeCategory: '航线分类',
      loadMode: '装载方式',
      expressCompany: '快递公司',
      expressAccount: '快递账号',
      serviceType: '服务类型'
    },
    conditionValues: {
      truck: '卡车',
      barge: '驳船',
      rail: '铁路'
    },
    fields: {
      markupMethods: '加价方式',
      densityLevel: '密度等级',
      railModes: '运输模式',
      vehicleType: '车型',
      basePrice1: '起步基价',
      basePrice2: '里程基价',
      unitPrice: '单价',
      minPrice: '最低价',
      maxPrice: '最高价',
      expressModels: '计费模型',
      firstWeightPrice: '首重单价',
      additionalWeightPrice: '续重单价',
      startWeight: '起始重量',
      endWeight: '结束重量',
      additionalUnitPrice: '续重加价'
    },
    markupMethods: {
      perContainer: '按箱型加价',
      perUnit: '按单价加价'
    },
    markups: {
      amountHint: '加价币种与基础费用一致',
      airModeHint: '未添加密度等级时需完整填写统一重量段；添加后需完整填写每个密度行',
      containerEmpty: '请点击「添加箱型列」配置各箱型加价值'
    },
    railModes: {
      container: '集装箱',
      ftl: '整车',
      ltl: '散货'
    },
    expressModels: {
      firstAdditional: '首重+续重',
      unitPrice: '单价计费',
      weightTier: '重量段'
    },
    airDensity: {
      all: '全部密度',
      level0To166: '0-166',
      level166To200: '166-200',
      level200To250: '200-250',
      level250To300: '250-300',
      level300To400: '300-400',
      level400To500: '400-500',
      level500Plus: '500以上'
    },
    actions: {
      addDensity: '添加密度等级',
      addVehicle: '添加车型',
      addWeightTier: '添加重量段'
    },
    placeholders: {
      containerTypes: '请选择箱型',
      vehicleType: '请选择平台业务数据中的车型',
      noUpperLimit: '留空表示无上限'
    },
    validation: {
      markupMethods: '请至少选择一种加价方式',
      containerMarkups: '请至少配置一个箱型及其加价值',
      unitMarkup: '请填写单价加价值',
      airMatrix: '请完整配置当前空运加价矩阵',
      airMatrixCell: '请填写密度“{density}”的“{tier}”重量段，加价值必须为大于或等于 0 的数字',
      railModes: '请至少选择一种铁路运输模式',
      railFtl: '请至少配置一个铁路整车车型',
      railVehicleRequired: '请选择铁路整车车型',
      railVehicleDuplicate: '同一铁路整车车型不能重复配置',
      railVehicleNotConfigured: '平台业务数据尚未配置可用的铁路车型',
      railVehicleInvalid: '规则中存在已停用或不存在的铁路车型，请重新选择',
      railLtl: '请配置铁路散货加价',
      expressModels: '请至少选择一种快递计费模型',
      expressTiers: '请至少配置一个快递重量段',
      expressValue: '请填写“{field}”，数值必须非负且最多保留两位小数',
      expressTierValue: '第 {row} 个重量段的“{field}”必须填写非负数，且最多保留两位小数',
      expressTierBoundary: '第 {row} 个重量段的结束重量必须大于起始重量',
      expressTierOpenEnd: '第 {row} 个重量段无上限，只能放在按起始重量排序后的最后一段',
      expressTierOverlap: '第 {row} 个重量段与其他区间重叠，请调整起止重量'
    },
    summary: {
      airDensityRows: '已配置 {count} 个密度等级',
      airUniform: '统一重量段加价',
      railFtlRows: '已配置 {count} 个车型',
      railLtl: '散货单价、最低价和最高价',
      expressTierRows: '已配置 {count} 个重量段'
    },
    messages: {
      typeMismatch: '规则业务类型与当前页面不一致',
      typeInvalid: '不支持的商务规则业务类型',
      railVehicleNotConfigured: '平台业务数据尚未配置可用的铁路车型',
      railVehicleLoadFailed: '铁路车型加载失败，请稍后重试'
    },
    confirm: {
      disableTitle: '确认禁用规则',
      disableContent: '禁用后规则状态将变为禁用，是否继续？',
      enableTitle: '确认启用规则',
      enableContent: '启用后规则状态将变为启用，是否继续？',
      deleteTitle: '确认删除规则',
      deleteContent: '删除后不可恢复，是否继续？',
      batchEnableTitle: '确认批量启用',
      batchEnableContent: '确认启用选中的 {count} 条规则？',
      batchDisableTitle: '确认批量禁用',
      batchDisableContent: '确认禁用选中的 {count} 条规则？',
      batchDeleteTitle: '确认批量删除',
      batchDeleteContent: '确认删除选中的 {count} 条规则？删除后不可恢复。'
    },
    list: {
      exportFilename: '{type}商务加价规则'
    }
  }
}
